module.exports = __webpack_public_path__ + "img/SecondaryWaterSupply.0cf8408e.png";